import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RegistrationFormComponent } from './registration-form/registration-form.component';
import { PhoneRecoveryEmailComponent } from './phone-recovery-email/phone-recovery-email.component';
import { PhoneUpdateRecoveryEmailComponent } from './phone-update-recovery-email/phone-update-recovery-email.component';
import { PhoneUpdateComponent } from './phone-update/phone-update.component';
import { PhoneVerificationComponent } from './phone-verification/phone-verification.component';
import { VerificationSuccessComponent } from './verification-success/verification-success.component';
import { CreatePasswordComponent } from './create-password/create-password.component';
import { RegistrationExpiredComponent } from './registration-expired/registration-expired.component';

const routes: Routes = [
  {
    path: '',
    component: RegistrationFormComponent,
  },
  {
    path: 'phone-verification',
    component: PhoneVerificationComponent
  },
  {
    path: 'phone-recovery-email',
    component: PhoneRecoveryEmailComponent
  },
  {
    path: 'phone-update',
    component: PhoneUpdateComponent
  },
  {
    path: 'phone-update-recovery-email',
    component: PhoneUpdateRecoveryEmailComponent
  },
  {
    path: 'create-password',
    component: CreatePasswordComponent
  },
  {
    path: 'verification-success',
    component: VerificationSuccessComponent
  },
  {
    path: 'reg-expired',
    component: RegistrationExpiredComponent
  },

 
]


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegistrationRoutingModule { }
